var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c("auto-number-input", {
        attrs: { precision: 0, min: 0, disabled: _vm.disabled },
        on: {
          change: function($event) {
            return _vm.onChange("quantityContract")
          }
        },
        model: {
          value: _vm.job.quantityContract,
          callback: function($$v) {
            _vm.$set(_vm.job, "quantityContract", $$v)
          },
          expression: "job.quantityContract"
        }
      }),
      _c("span", { staticStyle: { padding: "0 2px" } }, [_vm._v("/")]),
      _c("auto-number-input", {
        attrs: { precision: 0, disabled: _vm.disabled, min: 0 },
        on: {
          change: function($event) {
            return _vm.onChange("quantityActual")
          }
        },
        model: {
          value: _vm.job.quantityActual,
          callback: function($$v) {
            _vm.$set(_vm.job, "quantityActual", $$v)
          },
          expression: "job.quantityActual"
        }
      }),
      _c("span", { staticStyle: { "min-width": "50px" } }, [_vm._v("PCS")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }